import dayjs from "dayjs";
import type { TaxSubmissionStatus } from "../core/dtos/TaxSubmissionStatus";
import { store, type GovernmentAgencyHubAppStoreSlice } from "./store";

export enum SortableField {
    DEADLINE = "deadline",
    SEND_DATE = "sendDate",
    STATUS = "status",
}

export enum SortOrder {
    ASC = "asc",
    DESC = "desc",
}

interface SortConfig {
    field: SortableField;
    order: SortOrder;
}

export interface TaxSubmissionFilterSearch {
    deadlineFrom: Date;
    deadlineTo: Date;
    expired?: boolean;
    fullTextSearch?: string;
    intermediary?: string;
    operator?: string;
    page: number;
    pageSize: number;
    sort?: SortConfig;
    statuses: TaxSubmissionStatus[];
    taxPayer?: string;
    type?: string;
}

const defaultFilters: TaxSubmissionFilterSearch = {
    deadlineFrom: dayjs().subtract(1, "month").startOf("day").toDate(),
    deadlineTo: dayjs().add(1, "month").endOf("day").toDate(),
    expired: undefined,
    fullTextSearch: undefined,
    intermediary: undefined,
    operator: undefined,
    page: 0,
    pageSize: 10,
    statuses: [],
    sort: {
        field: SortableField.DEADLINE,
        order: SortOrder.DESC,
    },
    taxPayer: undefined,
    type: undefined,
};

const resetValues = () => {
    updateValues({
        ...defaultFilters,
        deadlineFrom: store.state.taxSubmissionsSearchFilters.deadlineFrom,
        deadlineTo: store.state.taxSubmissionsSearchFilters.deadlineTo,
        page: 0,
        pageSize: 10,
    });
};

const updateValues = (newValues: Partial<TaxSubmissionFilterSearch>) => {
    store.setState((state) => ({
        ...state,
        taxSubmissionsSearchFilters: {
            ...state.taxSubmissionsSearchFilters,
            page: 0, // reset to first page on every filter change unless page is explicitly set in newValues
            ...newValues,
        },
    }));
};

export const taxSubmissionsStoreSlice: GovernmentAgencyHubAppStoreSlice<TaxSubmissionFilterSearch> =
    {
        defaultValues: defaultFilters,
        resetValues: resetValues,
        updateValues: updateValues,
    };
